import { ticketsApi, useAuthMutation } from '@sunrise-ui/api-client';
import { useSnackbar } from '@sunrise-ui/primitives';

export const useCreateTicketToken = () => {
  const { showSnackbar } = useSnackbar();

  return useAuthMutation({
    async mutationFn(eventId: string) {
      const response =
        await ticketsApi.createEventTicketTokenTicketsEventsEventIdTokenPost({
          eventId,
        });
      return response.data;
    },
    async onError() {
      showSnackbar({
        text: 'Failed to join event. Please try again.',
        type: 'error',
      });
    },
  });
};
